import script from "./pdf-preview.vue?vue&type=script&lang=ts&setup=true"
export * from "./pdf-preview.vue?vue&type=script&lang=ts&setup=true"

import "./pdf-preview.vue?vue&type=style&index=0&id=01dd2094&lang=less&scoped=true"

import exportComponent from "E:\\Project\\health-force-aia-client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-01dd2094"]])

export default __exports__